import { FC } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { Menu, MenuDivider, MenuItem } from "mds/components/Menu";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { ArrowDownIcon, ChevronDownIcon } from "mds/icons";

interface AssessmentSummaryReportMenuProps {
  disabled: boolean;
  onSummaryReport: () => void;
  onDetailedReport: () => void;
  onFullReport: () => void;
}

export const AssessmentSummaryReportMenu: FC<AssessmentSummaryReportMenuProps> = ({
  disabled,
  onSummaryReport,
  onDetailedReport,
  onFullReport,
}) => {
  const MenuButton = (
    <SquareButton disabled={disabled} kind="tertiary" size="s">
      <IconText iconEnd={<ChevronDownIcon />} text={t("assessment_summary_report.menu.title")} />
    </SquareButton>
  );

  return (
    <Menu menuButton={MenuButton}>
      <MenuItem eventName="Assessment Summary Report - Export Summary" onClick={onSummaryReport}>
        <div className="flex items-start gap-2">
          <ArrowDownIcon className="mt-1" />

          <div className="flex flex-col">
            <div className="font-medium">
              {t("assessment_summary_report.menu.summary_report.title")}
            </div>

            <div className="text-xs text-black-tint-40">
              {t("assessment_summary_report.menu.summary_report.description")}
            </div>
          </div>
        </div>
      </MenuItem>

      <MenuDivider />

      <MenuItem eventName="Assessment Summary Report - Export Detailed" onClick={onDetailedReport}>
        <div className="flex items-start gap-2">
          <ArrowDownIcon className="mt-1" />
          <div className="flex flex-col">
            <div className="font-medium">
              {t("assessment_summary_report.menu.detailed_report.title")}
            </div>

            <div className="text-xs text-black-tint-40">
              {t("assessment_summary_report.menu.detailed_report.description")}
            </div>
          </div>
        </div>
      </MenuItem>

      <MenuDivider />

      <MenuItem eventName="Assessment Summary Report - Export Full" onClick={onFullReport}>
        <div className="flex items-start gap-2">
          <ArrowDownIcon className="mt-1" />
          <div className="flex flex-col">
            <div className="font-medium">
              {t("assessment_summary_report.menu.full_report.title")}
            </div>

            <div className="text-xs text-black-tint-40">
              {t("assessment_summary_report.menu.full_report.description")}
            </div>
          </div>
        </div>
      </MenuItem>
    </Menu>
  );
};
